import React, {useEffect, useRef, useState} from 'react';
import StarRating from '../../components/StarRating/StarRating';
import s from './TourDetails.module.scss'
import TourDescription from './TourDescription';
import TourPlans from './TourPlans';
import TourQa from './TourQa';
import ReviewSummary from '../ReviewList/ReviewSummary';
import {useNavigate, useParams} from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import AboutPrice from './AboutPrice';
import RelatedTours from '../../components/RelatedTours/RelatedTours';
import Loading from '../../components/Loading/Loading';
import ShareMenu from '../../components/ShareMenu/ShareMenu';
import {FaExclamationTriangle} from "react-icons/fa";
import {GoNote} from "react-icons/go";
import BookNow from "./BookNow";
import titleImage from '../../assets/images/titleImage.png';
import LoadingInside from "../../components/Loading/LoadingInside";
import SeoMeta from "../../components/SeoMeta";
import {FavoriteBorderOutlined, FavoriteOutlined} from "@mui/icons-material";
import {isInWishlist, toggleWishlist} from '../../components/wishList/wishlist';

const TourDetailsNew = ({
                            rezdyId: propRezdyId = "",
                            isCombo = false,
                            combo = null,
                            activeTour = null,
                            onComboTourCompleted = null
                        }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const params = useParams();

    const rezdyId =
        propRezdyId || params.rezdyId;
    const [, setIsMobile] = useState(false);
    const [activeTab, setActiveTab] = useState('price');
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadedImages, setLoadedImages] = useState({});
    const section1Ref = useRef(null);
    const section2Ref = useRef(null);
    const section3Ref = useRef(null);
    const section4Ref = useRef(null);
    const [isFavorite, setIsFavorite] = useState(() => isInWishlist(rezdyId));
    useEffect(() => {
        // immediate reset
        window.scrollTo(0, 0);

        // second correction after render + images/layout
        const timer = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);

        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        setIsFavorite(isInWishlist(rezdyId));
    }, [rezdyId]);
    const scrollToSection = (ref, tab) => {
        const offset = 130; // 👈 adjust based on your sticky header height

        const element = ref.current;
        const y = element.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });

        setActiveTab(tab);
    };
    const fetchTourDetails = async (rezdyId) => {
        try {
            setLoading(true);
            const response = await fetch(`${apiUrl}/api/tour/${rezdyId}`);

            if (!response.ok) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }

            const data = await response.json();

            setData(data);
        } catch (error) {
            console.error('Fetch error:', error);
        } finally {
            setLoading(false);
        }
    };

    const refreshReviews = async () => {
        if (data) {
            const response = await fetch(`${apiUrl}/api/tour/${rezdyId}`);
            if (response.ok) {
                const updatedData = await response.json();
                setData(updatedData);
            } else {
                console.error('Failed to fetch updated reviews');
            }
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        fetchTourDetails(rezdyId);
        // test(rezdyId)
    }, [rezdyId]);


    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        };
        new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setActiveTab(entry.target.dataset.tab);
                }
            });
        }, options);
    });
    if (loading) {
        return (
            <div className={s.container}>
                {isCombo ? <LoadingInside/> : <Loading/>}
            </div>
        );
    }

    if (!data) {
        return <div>No tour details found.</div>;
    }

    const {qas, schedules, tour, plans, reviews, related_tours, highlights} = data;
    const {tour_detail, images, tags} = tour;
    const otherInfo = tour_detail?.other_info
        ? JSON.parse(tour_detail.other_info)
        : [];


    const breadcrumbItems = [
        {name: 'ホーム', link: '/'},
        {name: tour.title},
    ];
    return (
        <>
            {!isCombo && (<SeoMeta
                slug={window.location.pathname}
                fallback={{
                    title: `${tour.title} `,
                    description: tour.details,
                    image: tour?.image1 ?? "",
                    url: `${process.env.REACT_APP_URL}${window.location.pathname}`
                }}
            />)}
            <div className="row">
                <div className="col-12">
                    {!isCombo && <Breadcrumb items={breadcrumbItems}/>}
                    {/*<script defer="" type="text/javascript" src="https://mightyaussie.rezdy.com/pluginJs"></script>*/}
                    <div className={s.titleContainer}>
                        <h2><img className={s.titleImage} src={titleImage}/>{tour.title}</h2>
                        <span className={s.code}>ツアーコード:{tour.tour_code}</span>
                        <ul className={s.tagList}>
                            {tags.map(tag => (
                                <li key={tag.id}>
                                    <span>{tag.name}</span>
                                </li>
                            ))}
                        </ul>
                        <div className={s.ratingSection}>
                            {tour.review_count > 0 && (
                                <div className={s.rating}>
                                    <StarRating score={tour.rating}/>
                                    <p className={s.rate}>{tour.rating}</p>
                                    <p className={s.count}>({tour.review_count})</p>
                                </div>
                            )}
                            <div className={s.actionButtons}>
                                <button
                                    type="button"
                                    className={`${s.favoriteButton} ${isFavorite ? s.favoriteActive : ''}`}
                                    onClick={() => {
                                        const result = toggleWishlist(rezdyId);
                                        setIsFavorite(result.isFavorite);
                                    }}
                                    aria-label={isFavorite ? "お気に入りから削除" : "お気に入りに追加"}
                                    aria-pressed={isFavorite}
                                >
                                    {isFavorite ? <FavoriteOutlined/> : <FavoriteBorderOutlined/>}

                                    <span className={s.favoriteText}>
            {isFavorite ? 'お気に入り済み' : 'お気に入り'}
        </span>
                                </button>

                                <ShareMenu title={tour.title}/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className={"row mt-5"}>

                <div className={"col-12 col-md-8"}>
                    {/*<div className={""}>*/}
                    <div className={`${s.stickyFix} ${s.fixedTourDetailsMenu}`}>
                        <div className={`nav nav-pills  `}>
                            <li className="nav-item">
                                <a
                                    className={`nav-link  ${s.btnOutline} ${activeTab === 'tab1' ? s.active : ''}`}
                                    onClick={() => scrollToSection(section1Ref, 'tab1')}
                                >
                                    ツアー行程
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${s.btnOutline} ${activeTab === 'tab2' ? s.active : ''}`}
                                    onClick={() => scrollToSection(section2Ref, 'tab2')}
                                >
                                    持ち物</a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${s.btnOutline} ${activeTab === 'tab3' ? s.active : ''}`}
                                    onClick={() => scrollToSection(section3Ref, 'tab3')}
                                >
                                    よくある質問</a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${s.btnOutline}  ${activeTab === 'tab4' ? s.active : ''}`}
                                    onClick={() => scrollToSection(section4Ref, 'tab4')}
                                >
                                    LINE相談</a>
                            </li>

                        </div>
                    </div>
                    {/*</div>*/}

                    {images && images.length > 0 && (
                        <div className="row">
                            <div className="col-12">

                                <div id="carouselTourImages" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-inner">

                                        {images.map((image, index) => (
                                            <div
                                                key={index}
                                                className={`carousel-item ${index === 0 ? "active" : ""}`}
                                            >
                                                <div className={s.carouselImageWrapper}>
                                                    <img
                                                        className="d-block w-100"
                                                        src={image?.image_url || ''}
                                                        alt={`サムネイル ${index + 1}`}
                                                    />
                                                </div>
                                            </div>
                                        ))}

                                    </div>

                                    <button className="carousel-control-prev" type="button"
                                            data-bs-target="#carouselTourImages" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon"></span>
                                    </button>

                                    <button className="carousel-control-next" type="button"
                                            data-bs-target="#carouselTourImages" data-bs-slide="next">
                                        <span className="carousel-control-next-icon"></span>
                                    </button>

                                </div>

                            </div>
                        </div>
                    )}


                    <div ref={section1Ref} className={"row"}>
                        <div className={"col-12"}>
                            <TourPlans plans={plans}/>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            {highlights && highlights.length > 0 && (
                                <>
                                    <div className="row mt-4">
                                        <div className="col-12">
                                            <h4>ハイライト</h4>

                                            {highlights.map((item) => (
                                                <div key={item.id} className="row mt-3 mb-3">

                                                    <div className="col-12 col-md-5">
                                                        <div className={s.imageWrapper}>
                                                            {/* Facebook-style skeleton */}
                                                            {!loadedImages[item.image] && (
                                                                <div className={s.skeleton}/>
                                                            )}
                                                            <img
                                                                src={item.image}
                                                                className={`${s.image} ${
                                                                    loadedImages[item.image] ? s.show : ''
                                                                }`}
                                                                loading="lazy"
                                                                alt=""
                                                                onLoad={() =>
                                                                    setLoadedImages(prev => ({
                                                                        ...prev,
                                                                        [item.image]: true
                                                                    }))
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-7">
                                                        <h5 className={s.heighlightTitle}>{item.title}</h5>
                                                        <p className={s.heighlightDescription}>{item.discription}</p>
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <hr/>
                                </>
                            )}
                        </div>
                    </div>
                    {(tour_detail.items || tour_detail.options || otherInfo.length > 0) && (
                        <div ref={section2Ref} className={"row mt-4"}>
                            <div className="col-12">
                                {tour_detail.items &&
                                    (
                                        <div className={"row mt-4   mb-3 "}>
                                            <div className="col-12">
                                                <h4 className={"fw-bold"}>持ち物</h4>
                                            </div>
                                            <div className={"col-12"}>
                                                {tour_detail.items.split('\n').map((line, index) => (
                                                    <p className={s.newLine} key={index}>{line}</p>

                                                ))}
                                            </div>
                                        </div>
                                    )}
                                {tour_detail.options && (
                                    <div className={"row mt-4  mb-3"}>
                                        <div className="col-12">
                                            <h4 className="fw-bold">オプション</h4>

                                        </div>
                                        <div className={"col-12"}>
                                            {tour_detail.options &&
                                                (
                                                    <div className="">

                                                        <div className="card shadow-sm border-0">
                                                            <div className="card-body p-0">

                                                                {tour_detail.options.map((item, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className={`d-flex justify-content-between align-items-start p-3 
                            ${index !== tour_detail.options.length - 1 ? "border-bottom" : ""}`}
                                                                    >

                                                                        {/* LEFT */}
                                                                        <div>
                                                                            <div className="fw-semibold">
                                                                                {item.name}
                                                                            </div>

                                                                            {item.remarks && (
                                                                                <div className="text-muted small mt-1">
                                                                                    {item.remarks}
                                                                                </div>
                                                                            )}
                                                                        </div>


                                                                    </div>
                                                                ))}

                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                )}
                                {otherInfo.length > 0 && (
                                    <div className="row mt-4 mb-3 ">
                                        <div className="col-12">
                                            <h4 className="fw-bold">その他情報</h4>

                                            <div className="card shadow-sm border-0">
                                                <div className="card-body">

                                                    {otherInfo.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className={`py-1 ${
                                                                index !== otherInfo.length - 1
                                                                    ? "border-bottom"
                                                                    : ""
                                                            }`}
                                                        >
                                                            <div className="fw-semibold">
                                                                {item.label}
                                                            </div>

                                                            <div className="text-muted mt-1">
                                                                {item.value}
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>


                    )}

                    <div ref={section3Ref} className={"row"}>
                        <div className={"col-12"}>
                            {tour_detail.qa &&
                                (
                                    <TourQa qaData={tour_detail.qa}/>
                                )}
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <TourDescription data={tour_detail}/>
                        </div>

                        {tour_detail?.notes && (
                            <div className={"col-12"}>
                                <div className={s.notes}>
                                    <GoNote className={s.noteIcon}/>
                                    <div>{tour_detail.notes}</div>
                                </div>
                            </div>
                        )}
                        {tour_detail?.warning && (
                            <div className={"col-12"}>
                                <div className={s.warning}>
                                    <FaExclamationTriangle className={s.warningIcon}/>
                                    {tour_detail.warning.split('\n').map((item, index) => (
                                        <p key={index}>・{item}</p>
                                    ))}
                                </div>
                            </div>
                        )}
                        {/*{tour_detail?.html_content && (*/}
                        {/*    <div className={"col-12"}>*/}
                        {/*        <div className={s.html}*/}
                        {/*             dangerouslySetInnerHTML={{__html: tour_detail.html_content}}/>*/}
                        {/*    </div>*/}

                        {/*)}*/}
                    </div>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            {tour_detail.about_price &&
                                (
                                    <AboutPrice aboutPrice={tour_detail.about_price}/>
                                )}
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <ReviewSummary
                                data={tour}
                                reviews={reviews}
                                onReviewSubmitted={refreshReviews}
                            />
                        </div>
                    </div>

                </div>
                <div className={"col-12  col-md-4"}>
                    <div className={`${s.stickyFix} ${s.bookingContainer}`}>
                        <div className={s.bookingText}>今見ているツアー</div>

                        <BookNow
                            tour={tour}
                            plans={plans}
                            isCombo={isCombo}
                            combo={combo}
                            activeTour={activeTour}
                            onComboTourCompleted={onComboTourCompleted}
                        />

                    </div>
                </div>

            </div>
            <div className={"row"}>
                <div className={"col-12"}>
                    <RelatedTours tourId={rezdyId}/>
                </div>
            </div>

        </>
    )

};

export default TourDetailsNew;
